import React from 'react';
import ReviewAlbumManagement from './ReviewAlbumManagement';

export default function ActiveReviewManagement(props) {
  return <ReviewAlbumManagement {...props} starred={false} />;
}
